import { FC, PropsWithChildren } from 'react'
import { User } from '@app/types'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { AuthMenu, PageTitle } from '../general'

type AuthProps = {
  user?: User & { authed?: boolean }
  pageTitle: string
  pageSubtitle?: string
  translation: string
  headElement?: React.ReactElement | null
  smallContainer?: boolean
}

/* Initial app container rendering all content */
export const AuthContainer: FC<PropsWithChildren<AuthProps>> = ({
  user,
  children,
  pageTitle,
  pageSubtitle,
  translation,
  headElement,
  smallContainer = true,
}) => {
  const { t } = useTranslation(translation)

  return (
    <main
      className={`px-4 py-2 mx-auto container ${
        smallContainer ? 'max-w-5xl' : 'max-w-6xl'
      }`}
      id='main-content'
    >
      {headElement ? headElement : null}
      <PageTitle
        title={t(pageTitle)}
        rightButton={
          <AuthMenu
            authenticated={user?.loggedIn ?? user?.authed}
            icon='settings'
          />
        }
        subTitle={pageSubtitle ? t(pageSubtitle) : ''}
      />
      {children}
    </main>
  )
}
